import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, Typography, Card, CardActionArea } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { CANVAS_TEMPLATES } from '../data/canvasTemplates';
import theme from '../theme';
import { useT, useLang } from '../i18n/LanguageContext';

// Modal gallery of guided starter canvases.
export default function TemplatePicker({ open, onClose, onPick }) {
  const t = useT();
  const { lang } = useLang();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pr: 6 }}>
        <AutoAwesomeIcon sx={{ color: theme.home.cyan }} />
        {t('canvas.templatePicker.title')}
        <IconButton onClick={onClose} aria-label={t('canvas.templatePicker.close')} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ color: 'text.secondary', mb: 2.5 }}>
          {t('canvas.templatePicker.body')}
        </Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
          {CANVAS_TEMPLATES.map((tpl) => (
            <Card key={tpl.id} variant="outlined" sx={{ borderRadius: 3 }}>
              <CardActionArea onClick={() => onPick(tpl)} sx={{ p: 2.5, height: '100%', alignItems: 'flex-start' }}>
                <Typography sx={{ fontWeight: 700, fontSize: '1.05rem', mb: 0.5 }}>{tpl.title(lang)}</Typography>
                <Typography sx={{ color: 'text.secondary', fontSize: '0.9rem', lineHeight: 1.5 }}>
                  {tpl.description(lang)}
                </Typography>
              </CardActionArea>
            </Card>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
